import { createGtm } from '@gtm-support/vue-gtm';
import VueSafeTeleport from 'vue-safe-teleport';
import VueSignaturePad from 'vue-signature-pad';
import VueTelInput from 'vue-tel-input';
import config from '@/config';
import router from '@/router';
import ComponentBase from './plugins/ComponentBase';
import Intercom from './plugins/Intercom';

export default (app: any) => {
  app.use(ComponentBase);
  app.use(VueSignaturePad);
  app.use(VueSafeTeleport);
  app.use(VueTelInput);

  app.use(Intercom, {
    intercomId: config.intercomId,
  });

  if (config.gtmId) {
    app.use(
      createGtm({
        id: config.gtmId,
        source: config.gtmUrl,
        vueRouter: router,
      }),
    );
  }
};
